module.exports = __webpack_public_path__ + "static/media/ZHUHAI-1 01 (CAS 4A).03ccb533.czml";